import { FormValues } from "../OwnerThreshold/types";
import { Profile } from "./types";

export const hasChildProfiles = (
  targetProfileId: number,
  profiles: (Profile | null)[] | undefined,
): boolean => {
  if (!profiles) return false;

  return profiles.some((profile) =>
    profile?.parentRelationships?.some(
      (rel) => rel.relationshipType === "owner" && rel.parentProfileId === targetProfileId,
    ),
  );
};

export interface ChildProfileInfo {
  names: string[];
  ids: number[];
}

export const getChildProfileNamesAndIds = (
  targetProfileId: number,
  profiles: (Profile | null)[] | undefined,
): ChildProfileInfo => {
  if (!profiles) return { names: [], ids: [] };

  const validProfiles = profiles
    .filter((profile): profile is Profile => profile !== null)
    .filter((profile) =>
      profile?.parentRelationships?.some(
        (rel) => rel.relationshipType === "owner" && rel.parentProfileId === targetProfileId,
      ),
    );

  const names = validProfiles
    .map((profile) => {
      if (profile?.complianceObjectType === "individual") {
        const nameParts = [profile.firstName];
        if (profile.middleName) {
          nameParts.push(profile.middleName);
        }
        nameParts.push(profile.lastName);
        return nameParts.filter(Boolean).join(" ");
      }
      return profile?.legalName ?? "";
    })
    .filter(Boolean);

  const ids = validProfiles.map((profile) => profile.id);

  return { names, ids };
};

export const getInitialValues = (
  areOwnersCompleted: boolean | undefined,
  hasOwners: boolean,
): FormValues => {
  if (hasOwners) {
    return { ownerThresholdQuestion: "yes" };
  } else {
    if (areOwnersCompleted) {
      return { ownerThresholdQuestion: "no" };
    } else {
      return { ownerThresholdQuestion: "" };
    }
  }
};
